<script setup lang="ts">
import { EvmHomeTotalTokenInfo } from '~/api/repository'
import { useFetchGeneral } from '~/api/service/general/index.service'
import BarChart from '~/components/chart/BarChart.vue'
import CustomSuspense from '~/components/suspense/CustomSuspense.vue'
import IconTooltip from '~/components/tooltip/IconTooltip.vue'
import { HOME_CHART_TOOLTIP } from '~/constants/general.const'
import { IMAGE_BASE_URL } from '~/constants/image.constant'
import { generalParamType } from '~/types/general.type'
import TKNTP = EvmHomeTotalTokenInfo.TKNTP;
import HomeCardTitle from '~/components/@pages/home/HomeCardTitle.vue'
import HomeChartTitle from '~/components/@pages/home/HomeChartTitle.vue'

const { data, isLoading } = useFetchGeneral([ generalParamType.TOKEN ])

const getTokenTypeTitle = (type: string) => type.slice(0, 3).concat('-', type.slice(3))

const colors = {
  [TKNTP.ERC20]: '#5c8ffa',
  [TKNTP.ERC721]: '#4feab2',
  [TKNTP.ERC1155]: '#ad3df9',
}
</script>

<template>
  <div>
    <CustomSuspense :is-loading="isLoading">
      <template #loading>
        <img
          :src="`${IMAGE_BASE_URL}/skeleton/home/three-bar-chart.png`"
          alt="line chart skeleton"
        >
      </template>
      <template #default>
        <div class="grid h-full grid-cols-3 gap-3">
          <Card
            v-for="tokenList in data.FTI.OBJ"
            :key="tokenList.TKNTP"
            class="flex flex-col justify-between p-4"
          >
            <div>
              <HomeChartTitle
                :title="`${getTokenTypeTitle(tokenList.TKNTP)}\nToken Transfer`"
                :tooltip="HOME_CHART_TOOLTIP[generalParamType.TOKEN](tokenList.TKNTP)"
              />
              <strong class="mt-2 block font-bold text-primary ">
                {{ setComma(tokenList.TTKNCNT) }}
              </strong>
            </div>
            <BarChart
              :data="tokenList.DTRXLIST.map(i => {
                return [ i.UT, i.TRXCNT ]
              })"
              :color="colors[tokenList.TKNTP]"
              :height="180"
              :formatter="(params) => {
                return `<p class='text-center'><span class='text-primary/40'>${params.name}</span><br />Transfers:
            ${setComma(params.value)}</p>`
              }"
            />
          </Card>
        </div>
      </template>
    </CustomSuspense>
  </div>
</template>

<style scoped lang="scss">
</style>